export const MAX = {
  // this comes from SEO spreadsheet
  TITLE: 60,
  DESCRIPTION: 155,
  TWITTER_DESCRIPTION: 200,
  OPENGRAPH_DESCRIPTION: 200,
};
